var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../elements/Basic");

var _FontelloIcon = _interopRequireDefault(require("../Basic/FontelloIcon"));

var _Touchable = _interopRequireDefault(require("../Basic/Touchable"));

var _PropsHelper = require("../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Formation/FormationPlayer.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var FormationPlayer = function (_React$Component) {
  (0, _inherits2.default)(FormationPlayer, _React$Component);

  var _super = _createSuper(FormationPlayer);

  function FormationPlayer() {
    var _this;

    (0, _classCallCheck2.default)(this, FormationPlayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.generatePlayerGoalKey = function (player, event, index) {
      return player.id + "_" + event + "_" + index;
    };

    return _this;
  }

  (0, _createClass2.default)(FormationPlayer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          player = _this$props.player,
          onPress = _this$props.onPress,
          itemWidth = _this$props.itemWidth,
          href = _this$props.href,
          NavWrapper = _this$props.NavWrapper;
      if (!player) return null;
      return _react.default.createElement(_Touchable.default, {
        onPress: onPress,
        flexing: true,
        style: (0, _PropsHelper.getValueConditionally)(itemWidth, {
          maxWidth: itemWidth
        }),
        href: href,
        NavWrapper: NavWrapper,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 23,
          columnNumber: 13
        }
      }, _react.default.createElement(_Basic.Column, {
        flexing: true,
        center: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 30,
          columnNumber: 17
        }
      }, _react.default.createElement(_Basic.Row, {
        flexing: true,
        evenly: true,
        center: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 31,
          columnNumber: 21
        }
      }, _react.default.createElement(_Basic.Row, {
        flexing: true,
        justifyContent: "flex-end",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 32,
          columnNumber: 25
        }
      }, player.events != null ? player.events.map(function (event, index) {
        switch (event) {
          case 'YELLOW_CARD':
            return _react.default.createElement(_FontelloIcon.default, {
              key: player.id + "_" + event,
              name: "card",
              color: "YELLOW_CARD",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 38,
                columnNumber: 51
              }
            });

          case 'RED_CARD':
            return _react.default.createElement(_FontelloIcon.default, {
              key: player.id + "_" + event,
              name: "card",
              color: "red",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 46,
                columnNumber: 51
              }
            });

          case 'YELLOW_RED_CARD':
            return _react.default.createElement(_Basic.Column, {
              key: player.id + "_" + event,
              position: "relative",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 54,
                columnNumber: 51
              }
            }, _react.default.createElement(_react.default.Fragment, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 58,
                columnNumber: 55
              }
            }, _react.default.createElement(_FontelloIcon.default, {
              name: "card",
              color: "YELLOW_CARD",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 59,
                columnNumber: 59
              }
            }), _react.default.createElement(_FontelloIcon.default, {
              name: "card-yellow-red",
              color: "RED_CARD",
              position: "absolute",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 63,
                columnNumber: 59
              }
            })));

          case 'SUBSTITUTE_IN':
            return _react.default.createElement(_FontelloIcon.default, {
              key: player.id + "_" + event,
              name: "exchange-in",
              color: "green",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 73,
                columnNumber: 51
              }
            });

          case 'SUBSTITUTE_OUT':
            return _react.default.createElement(_FontelloIcon.default, {
              key: player.id + "_" + event,
              name: "exchange-out",
              color: "red",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 81,
                columnNumber: 51
              }
            });

          default:
            return null;
        }
      }) : null), _react.default.createElement(_Basic.Text, {
        bold: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 93,
          columnNumber: 25
        }
      }, player.jerseyNumber), _react.default.createElement(_Basic.Row, {
        flexing: true,
        position: "relative",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 94,
          columnNumber: 25
        }
      }, player.events != null ? player.events.filter(function (item) {
        return item === 'GOAL';
      }).map(function (event, index) {
        return _react.default.createElement(_Basic.Column, {
          key: _this2.generatePlayerGoalKey(player, event, index),
          position: "relative",
          left: index * -7,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 99,
            columnNumber: 43
          }
        }, _react.default.createElement(_Basic.View, {
          top: "5px",
          left: "2px",
          width: 9,
          height: 9,
          borderRadius: 6,
          bg: "white",
          position: "absolute",
          zIndex: 1,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 104,
            columnNumber: 47
          }
        }), _react.default.createElement(_FontelloIcon.default, {
          name: "goal",
          color: "black",
          zIndex: 2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 114,
            columnNumber: 47
          }
        }));
      }) : null)), _react.default.createElement(_Basic.Row, {
        maxWidth: itemWidth || '100%',
        wrapContent: true,
        style: {
          fontSize: 'small'
        },
        mx: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 120,
          columnNumber: 21
        }
      }, _react.default.createElement(_Basic.Text, {
        numberOfLines: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128,
          columnNumber: 25
        }
      }, player.nickName || player.lastName))));
    }
  }]);
  return FormationPlayer;
}(_react.default.Component);

FormationPlayer.propTypes = {
  player: _propTypes.default.object.isRequired,
  onPress: _propTypes.default.func,
  itemWidth: _propTypes.default.number,
  NavWrapper: _propTypes.default.func
};
var _default = FormationPlayer;
exports.default = _default;